import React from "react";
import Header from "../components/dynamic/Header";
import { useProofStore } from "../store/proofStore";
import ErrorView from "./ErrorView";
import GenericListView from "../components/dynamic/GenericListView";
import { toTitleCase, processObjectData } from "../utils/viewUtils";
import SuccessIcon from "../components/utils/SuccessIcon";
import ProofDetails, {
  DetailLine,
} from "../components/view-specific/ProofDetails";
import ProofSignature from "../components/view-specific/ProofSignature";

const ProofCompletionView: React.FC = () => {
  const proof = useProofStore((s) => s.proof);

  if (!proof.data) {
    return <ErrorView />;
  }

  const { listKey, listData, otherData } = processObjectData(proof.data);

  return (
    <div className="flex flex-col items-center w-full px-8">
      <SuccessIcon className="mt-4" />
      <Header
        title="Success"
        subheader="Your data has been verified."
        className="pb-8"
      />

      {/* Render the generic list if listData exists */}
      {listData && listKey && (
        <GenericListView
          items={listData}
          listTitle={toTitleCase(listKey.replace(/_/g, " "))}
        />
      )}

      {/* Render other data points */}
      <ProofDetails title="Details" data={otherData} className="mb-1" />

      {/* Render Signature Separately */}
      {proof.signature && <ProofSignature signature={proof.signature} />}
    </div>
  );
};

export default ProofCompletionView;
